import { get, post } from "../../helpers/api_helper"

export const truncateDBOnly = () => {
    return get(`truncate-db`)
  }